//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
import { map, filter } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const galleryInitial = [];

export const one_game_gallery = (state = galleryInitial, action) => {
    switch (action.type) {
        case ActionTypes.one_game_gallery.create_one_game_gallery:
            return [action.payload, ...state];
        case ActionTypes.one_game_gallery.list_one_game_gallery:
            return action.payload;
        case ActionTypes.one_game_gallery.update_one_game_gallery:
            return map(state, dt => {
                if (dt.id === action.payload.id) {
                    return action.payload;
                }
                return dt;
            })
        case ActionTypes.one_game_gallery.delete_one_game_gallery:
            const idsToDelete = action.payload.map(item => item.id);
            return filter(state, dt => !idsToDelete.includes(dt.id));
        default:
            return state;
    }
};
